
export const PRODUCT_CATEGORIES = {
  SMARTPHONE: 'Smartphone',
  TABLET: 'Tablette',
  LAPTOP: 'Ordinateur portable',
  NAS: 'NAS & Serveur',
  ACCESSORY_CASE: 'Coque',
  ACCESSORY_SCREEN_PROTECTOR: 'Protection écran',
  ACCESSORY_CHARGER: 'Chargeur',
  ACCESSORY_CABLE: 'Câble',
  ACCESSORY_HEADPHONES: 'Écouteurs',
  ACCESSORY_POWERBANK: 'Batterie externe',
  ACCESSORY_OTHER: 'Autre accessoire',
  SPARE_PARTS: 'Pièce détachée'
};


export const PRODUCT_CONDITIONS = {
  NEW: 'Neuf',
  REFURBISHED_EXCELLENT: 'Reconditionné - Excellent état',
  REFURBISHED: 'Reconditionné - Très bon état',
  REFURBISHED_GOOD: 'Reconditionné - Bon état'
};


export const PRODUCT_CONDITIONS_BADGE = {
  NEW: 'Neuf',
  REFURBISHED_EXCELLENT: 'Excellent état',
  REFURBISHED: 'Très bon état',
  REFURBISHED_GOOD: 'Bon état'
};


export const USER_ROLES = {
  CLIENT: 'Client',
  ADMIN: 'Administrateur'
};


export const ORDER_STATUSES = {
  PENDING: 'En attente',
  PAID: 'Payée',
  READY_FOR_PICKUP: 'Prête au retrait',
  PICKED_UP: 'Retirée',
  CANCELLED: 'Annulée'
};


export const PAYMENT_STATUSES = {
  PENDING: 'En attente',
  PAID: 'Payé',
  FAILED: 'Échoué',
  REFUNDED: 'Remboursé'
};


export const CATEGORY_OPTIONS = Object.entries(PRODUCT_CATEGORIES).map(([value, label]) => ({
  value,
  label
}));


export const CONDITION_OPTIONS = Object.entries(PRODUCT_CONDITIONS).map(([value, label]) => ({
  value,
  label
}));


export const getCategoryLabel = (code) => PRODUCT_CATEGORIES[code] || code;
export const getConditionLabel = (code) => PRODUCT_CONDITIONS[code] || code;
export const getConditionBadgeLabel = (code) => PRODUCT_CONDITIONS_BADGE[code] || code;
export const getOrderStatusLabel = (code) => ORDER_STATUSES[code] || code;
export const getPaymentStatusLabel = (code) => PAYMENT_STATUSES[code] || code;
